// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

import { resourceStatus, DEFAULT_ID } from 'constants/loading';
import { defaultsDeep } from 'lodash';

// Action Types
export const typePrefix = 'vra/loading/';
export const actions = [
  'SET_RESOURCE_PENDING',
  'SET_RESOURCE_LOADED',
  'SET_RESOURCE_UNLOADED'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer (
  state = {},
  action = {}
) {
  let status;

  switch (action.type) {
    case actions.SET_RESOURCE_PENDING:
      status = resourceStatus.PENDING;
      break;
    case actions.SET_RESOURCE_LOADED:
      status = resourceStatus.LOADED;
      break;
    case actions.SET_RESOURCE_UNLOADED:
      status = resourceStatus.UNLOADED;
      break;
    default:
      return state;
  }
  // Conventionally complex logic does not live in the reducer
  // this is a very weird case, as the only alternative I could come up with
  // is sending a complete replacement state
  // which is really the same thing, it just moves the actual reducer reduction
  // If anyone has a cleaner implementation, feel free to implement

  // requests have ids and are grouped by types
  // a request is in only one status
  // state is [status][type][id] which feels reverse
  // but it makes it easier(ish) to ensure there are no other requests within that type
  // for a given status (when exclusive flag is used).  Instead the logic to
  // make sure a [type][id] does not exist in other statuses is a little complex
  //
  const allStatuses = Object.values(resourceStatus);
  const { id, type, promise, exclusive } = action.payload;
  defaultsDeep(state, { [status]: { [type]: { [id]: {}}}});

  const generateStateForTypeInStatus = ( typeInStatus, typeName ) => {
    // for every type within this status, yank out any changed type.id
    return Object.keys(typeInStatus)
    .filter( idName => !(typeName === type && idName === id) )
    .reduce( (newType, idName) => ({
      ...newType,
      [idName]: {...typeInStatus[idName] }
    }), {});
  };

  const generateStateForStatus = status => {
    // for every known status, get the updated state
    return Object.keys(status)
    .reduce( (newStatus, typeName) => ({
      ...newStatus,
      [typeName]: generateStateForTypeInStatus(status[typeName], typeName)
    }), {});
  };

  const freshState = {
    // First, the new state for the chosen status
    [status]: {
      ...state[status],
      [type]: {
        ...(exclusive ? {} : {...state[status][type]}),
        ...(id ? {
          [id]: {
            status: true,
            promise
          }
        } : {} )
      }
    },
    // Then the new state for the other statuses, minus any type.id that changed to new status above
    ...allStatuses
    .filter( statusName => state[statusName] && statusName !== status )
    .reduce( (newState, statusName) => ({
      ...newState,
      [statusName]: generateStateForStatus(state[statusName])
    }), {})
  };
  return freshState;
}

// Action Creators

export const setResourcePending = ({ type, id=DEFAULT_ID, promise, exclusive }) => {
  return {
    type: actions.SET_RESOURCE_PENDING,
    payload: { type, id, promise, exclusive }
  };
};

export const setResourceLoaded = ({ type, id=DEFAULT_ID }) => {
  return {
    type: actions.SET_RESOURCE_LOADED,
    payload: { type, id }
  };
};

export const setResourceUnloaded = ({ type, id=DEFAULT_ID }) => {
  return {
    type: actions.SET_RESOURCE_UNLOADED,
    payload: { type, id }
  };
};

export const endPendingResourcesOfType = ({ type }) => {
  return {
    type: actions.SET_RESOURCE_PENDING,
    payload: { type, exclusive: true }
  };
};


